import { Component, OnInit } from '@angular/core';
import { Message} from 'primeng/primeng';
import { ConfirmationService} from 'primeng/primeng';
import { SelectItem} from 'primeng/primeng';
import { AlarmTypeService} from '../services/alarm-type.service';

@Component({
  selector: 'app-alarm-type',
  templateUrl: './alarm-type.component.html',
  styleUrls: ['./alarm-type.component.css']
})
export class AlarmTypeComponent implements OnInit {

  msgs: Message[] = [];
  alarmType: any;
  alarmTypes : any [];
  displayAdd: boolean = false;
  displayEdit: boolean = false;
  status: SelectItem[];
  blockedDocument: boolean = false;

  constructor(private alarmTypeService : AlarmTypeService,private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.init();
    this.status = [
            {label: 'Habilitado', value: 'H', icon: 'fa fa-check-square-o'},
            {label: 'Inhabilitado', value: 'I', icon: 'fa fa-square-o'}
        ];
  }
  init(){
    this.alarmTypes = [];
    this.alarmTypeService.findAll().then(data => {
      let response: any = data;
      response.alarmTypes.forEach(item => {
        this.alarmTypes.push(item);
      });
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
    });
    this.alarmType = {status:"H"};
    this.displayAdd = false;
    this.displayEdit = false;
  }

  showAdd(){
    this.displayAdd = true;
  }

  showEdit(alarmType:any){
    this.alarmType=alarmType;
    this.displayEdit = true;
  }

  hide(){
    this.alarmType = {status:"H"};
    this.displayAdd = false;
    this.displayEdit = false;
  }

  add(){
    this.blockedDocument = true;
    this.alarmTypeService.create(this.alarmType).then(data =>{
      let response: any = data;
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'info', summary:'INFO', detail:'Registro insertado exitosamente'}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blockedDocument = false;
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
        this.blockedDocument = false;
    });
  }

  edit(){
    this.blockedDocument = true;
    this.alarmTypeService.edit(this.alarmType).then(data =>{
      let response: any = data;
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'info', summary:'INFO', detail:'Registro modificado exitosamente'}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blockedDocument = false;
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
        this.blockedDocument = false;
    });
  }

  del(id: String){
    this.confirmationService.confirm({
            message: 'Esta seguro de eliminar el registro seleccionado?',
            header: 'Confirmación',
            icon: 'fa fa-trash',
            accept: () => {
                this.blockedDocument = true;
                this.alarmTypeService.remove(id).then(data =>{
                  let response: any = data;
                    if(response.status == 'OK'){
                      this.init();
                      this.msgs = [{severity:'info', summary:'INFO', detail:'Registro eliminado exitosamente'}];
                    }else{
                      this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
                    }
                    this.blockedDocument = false;
                }).catch(err =>{
                    this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
                    this.blockedDocument = false;
                });
            }
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/alarm-type/alarm-type.component.ts